import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { IconFolderSolid } from '@instructure/ui-icons';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
var OutcomeFolder = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeFolder, _React$Component);
  var _super = _createSuper(OutcomeFolder);
  function OutcomeFolder() {
    var _this;
    _classCallCheck(this, OutcomeFolder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleClick = function (id) {
      var _this$props = _this.props,
        setActiveCollection = _this$props.setActiveCollection,
        toggleExpandedIds = _this$props.toggleExpandedIds,
        activeCollectionId = _this$props.activeCollectionId;
      if (activeCollectionId) {
        toggleExpandedIds({
          id: activeCollectionId,
          forceOpen: true
        });
      }
      setActiveCollection(id);
      toggleExpandedIds({
        id: id,
        forceOpen: true
      });
    };
    _this.renderTitle = function (outcome) {
      var clickable = _this.props.clickable;

      // Temporarily have the Folders rendered in search results
      // be unclickable, until we decide how to retrieve all
      // their ancestor outcomes and put them into state. A necessary
      // reqt in order to render the tree picker.
      return clickable ? jsx(Text, {
        size: "small"
      }, jsx(Link, {
        onClick: function onClick() {
          return _this.handleClick(outcome.id);
        }
      }, outcome.title)) : jsx(Text, {
        size: "x-small"
      }, outcome.title);
    };
    return _this;
  }
  _createClass(OutcomeFolder, [{
    key: "renderSummary",
    value: function renderSummary(outcome) {
      var getOutcomeSummary = this.props.getOutcomeSummary;
      if (getOutcomeSummary(outcome.id)) {
        return jsx("div", {
          css: this.props.styles.folderSummary
        }, jsx(Text, {
          size: "x-small"
        }, getOutcomeSummary(outcome.id)));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var outcome = this.props.outcome;
      return jsx("div", {
        css: this.props.styles.folder
      }, jsx("div", {
        css: this.props.styles.folderIcon
      }, jsx(IconFolderSolid, null)), jsx("div", {
        css: this.props.styles.folderDetails
      }, jsx("div", {
        "data-automation": "outcomeFolder__folderTitle"
      }, this.renderTitle(outcome)), this.renderSummary(outcome), jsx("div", {
        css: this.props.styles.folderDescription
      }, jsx(Text, {
        size: "x-small"
      }, outcome.label))));
    }
  }]);
  OutcomeFolder.displayName = "OutcomeFolder";
  return OutcomeFolder;
}(React.Component), _class2.propTypes = {
  outcome: PropTypes.object.isRequired,
  clickable: PropTypes.bool,
  getOutcomeSummary: PropTypes.func.isRequired,
  setActiveCollection: PropTypes.func.isRequired,
  toggleExpandedIds: PropTypes.func.isRequired,
  activeCollectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: stylesShape
}, _class2.defaultProps = {
  clickable: true,
  activeCollectionId: null
}, _class2)) || _class);
export { OutcomeFolder as default };